import { numberToPrettyString } from '@cian/utils';

import { IPromoInfo } from '../../../types/newbuildingPromos';

export const getInterestRate = (promo: IPromoInfo): string => {
  const interestRate = promo.mortgageParams?.interestRate;

  if (!interestRate && interestRate !== 0) {
    return '—';
  }

  const roundedNumber = Math.round(interestRate * 100) / 100;

  return `${numberToPrettyString(roundedNumber)}%`;
};
